<template>
  <main>
    <div class="chips">
      <div
        v-for="(category, index) in availableCategories"
        :key="index"
        @click="toggleCategory(category)"
        :class="{ selected: selectedCategories.includes(category) }"
      >
        {{ category }}
      </div>
    </div>

    <article class="info-box" v-for="(article, index) in filteredArticles" :key="index">
      <div class="image-top">
        <img :src="article.image" :alt="article.title">
      </div>
      <div class="flow">
        <h1>{{ article.title }}</h1>
        <div v-for="tag in article.tags" :key="tag">
          <span :style="{ color: tagColors[tag] }">{{ tag }}</span>
        </div>
        <p class="paragraph">{{ article.content }}</p>
      </div>
    </article>
  </main>
</template>

<script>
export default {
  data() {
    return {
      tagColors: {
        travel: "#6abecd",
        "food & drink": "#cf6390",
        photography: "#3e54a3",
      },
      articles: [
        {
          title: "Value Investing",
          tags: ["Value", "StingyCat"],
          content: "Sed risus felis, porta sed mattis quis...",
          image:
            "https://images.unsplash.com/photo-1681157578627-5ca12bc38c4e?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxjb2xsZWN0aW9uLXBhZ2V8MXw5SWlwT2xoVU1yVXx8ZW58MHx8fHw%3D&auto=format&fit=crop&w=500&q=60",
        },
        {
          title: "The Next Plan in Travel",
          tags: ["travel", "StingyCat"],
          content: "Sed risus felis, porta sed mattis quis...",
          image:
            "https://images.unsplash.com/photo-1681157578627-5ca12bc38c4e?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxjb2xsZWN0aW9uLXBhZ2V8MXw5SWlwT2xoVU1yVXx8ZW58MHx8fHw%3D&auto=format&fit=crop&w=500&q=60",
        },
        {
          title: "The Next Plan in Travel",
          tags: ["travel"],
          content: "Sed risus felis, porta sed mattis quis...",
          image:
            "https://images.unsplash.com/photo-1681157578627-5ca12bc38c4e?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxjb2xsZWN0aW9uLXBhZ2V8MXw5SWlwT2xoVU1yVXx8ZW58MHx8fHw%3D&auto=format&fit=crop&w=500&q=60",
        },
        {
          title: "The Next Plan in Travel",
          tags: ["food & drink"],
          content: "Sed risus felis, porta sed mattis quis...",
          image:
            "https://images.unsplash.com/photo-1681157578627-5ca12bc38c4e?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxjb2xsZWN0aW9uLXBhZ2V8MXw5SWlwT2xoVU1yVXx8ZW58MHx8fHw%3D&auto=format&fit=crop&w=500&q=60",
        },
        // Add more articles here
      ],
      selectedCategories: [],
    };
  },
  computed: {
    availableCategories() {
      const categories = new Set();
      for (const article of this.articles) {
        article.tags.forEach((tag) => categories.add(tag));
      }
      return Array.from(categories);
    },
    filteredArticles() {
      if (this.selectedCategories.length === 0) {
        return this.articles;
      } else {
        return this.articles.filter((article) =>
          article.tags.some((tag) => this.selectedCategories.includes(tag))
        );
      }
    },
  },
  methods: {
    toggleCategory(category) {
      if (this.selectedCategories.includes(category)) {
        // Category is already selected, so remove it
        this.selectedCategories = this.selectedCategories.filter(
          (selectedCategory) => selectedCategory !== category
        );
      } else {
        // Category is not selected, so add it
        this.selectedCategories.push(category);
      }
    },
  },
};
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Codystar&display=swap');

:root {
  --bg-card: rgb(255, 250, 250);
  --clr-background: rgb(14, 16, 26);

  --fw-200: 200;
  --fw-300: 300;
  --fw-400: 400;
  --fw-500: 500;
  --fw-600: 600;
  --fw-700: 700;
  --fw-800: 800;

  --fs-300: 0.6875rem;
  --fs-400: 0.8125rem;
  --fs-500: 1rem;
  --fs-550: 1.1rem;
  --fs-600: 1.2rem;
  --fs-700: 1.5rem;
}

*,
*::before,
*::after {
  box-sizing: border-box;
}

body {
  font-family: "Dosis", sans-serif;
  display: grid;
  place-content: center;
  min-height: 100vh;
  background-color: var(--clr-background);
  margin: 0;
}

main {
  display: grid;
  gap: 3rem;
  padding: 5rem 2rem;
  width: min(95%, 75rem);
  margin-inline: auto;
}

.chips {
  display: flex;
  gap: 5px; /* Smaller gap */
  margin-bottom: 20px;
  height: 25px;
}

.chips div {
  cursor: pointer;
  padding: 3px 6px; /* Smaller padding */
  border-radius: 10px; /* Smaller border radius */
  transition: background-color 0.3s ease-in-out; /* Smooth transition */
}

.chips div.selected {
  background-color: #6a0dad; /* Purple silver color when selected */
  color: white;
}

.chips div:not(.selected) {
  background-color: #ccc; /* Grey color when not selected */
  color: black; /* Text color when not selected */
}

.info-box {
  border-radius: 0.5rem;
  box-shadow: 2rem 3rem 2rem -2rem hsla(221, 7%, 45%, 0.492);
  background-color: white ;
}

.info-box img {
  width: 100%;
  object-fit: cover;
  aspect-ratio: 3/2;
  border-radius: 0.5rem 0.5rem 0 0;
  transition: all 0.5s ease-in-out;
}

.image-top img {
  object-position: 50% 40%;
}

.image-bottom img {
  object-position: 50% 100%;
}

.info-box img:hover {
  border-radius: 0.5rem 0.5rem 0 0;
  border: 1rem solid transparent;
  background: linear-gradient(black, black) padding-box,
    linear-gradient(45deg, #3bccc0, #c86feb) border-box;
}

.flow {
  padding: 2rem 3rem;
}

h1 {
  font-weight: var(--fw-500);
  font-size: var(--fs-700);
}

span {
  font-size: var(--fs-600);
  font-weight: var(--fw-600);
  text-transform: uppercase;
  margin: 0.5rem 0.5rem 0 0;
}

.paragraph {
  font-size: var(--fs-550);
  line-height: 1.5;
  margin: 1.5rem 0;
}

.links {
  display: flex;
}

.links a {
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  font-size: 1rem;
  color: #fff;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  cursor: pointer;
  text-decoration: none;
  margin-right: 0.7rem;
  transition: all 0.5s ease-in-out;
}

.links a:hover {
  transform: scale(1.1);
  -webkit-transform: scale(1.1);
  -moz-transform: scale(1.1);
}

.spotify {
  background-color: #10a224;
}

.instagram {
  background-color: #527fa6;
}

.twitter {
  background-color: #2b97f1;
}

.youtube {
  background-color: #cf263c;
}

.pinterest {
  background-color: #a13079;
}

@media (min-width: 750px) {
  main {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (min-width: 1200px) {
  main {
    grid-template-columns: repeat(3, 1fr);
  }
}
</style>
